/**
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Space} Space
 */

export {toParse5} from './lib/index.js'
